/** @jsx jsx */
import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * Sets the height of this component. Accepts any valid emotion CSS value for
   * the `height` property.
   */
  height?: string | number;
  /**
   * Sets the width of this component. Accepts any valid emotion CSS value for
   * the `width` property.
   */
  width?: string | number;
};

const Styles = labelStyles('Spacer', {
  root: (props: Props) => [
    {
      label: `${props.width || 0}-by-${props.height || 0}`,
      width: props.width,
      height: props.height,
    },
  ],
});

/**
 * Adds space between things.
 *
 * As an alternative to adding `margin` directly to a component, `Spacer`
 * allows for space to be added _between_ components without needing to modify
 * their styles, or wrap them in `div`s.
 */
export const Spacer = ({ width = 0, height = 0 }: Props) => {
  return <div css={Styles.root({ width, height })} data-zds />;
};
